var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclaimer-main cursor-pointer",class:{
      stylized1: _vm.stylized === '0',
      stylized2: _vm.stylized === '1'
    },on:{"click":_vm.more}},[_c('div',{staticClass:"content",class:{
        ellipsis: !_vm.index
      },domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.content)?_c('i',{class:['icon', 'el-icon-arrow-up', { lmethod: !_vm.index }]}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }